import { StarOutline } from '@material-ui/icons';
import { Rating } from '@material-ui/lab';

export default function RatingView({ parameter, rating = {}, className = '' }) {
  return (
    <div key={parameter} className={className}>
      {
        {
          string: (
            <>
              <span>{rating.value || '-'}</span>
            </>
          ),
          number: (
            <>
              <Rating
                max={rating.maxLength}
                emptyIcon={
                  <StarOutline
                    color='inherit'
                    className='text-opacity-30 dark:text-opacity-60 text-ab-primary dark:text-ab-tertiary'
                  />
                }
                value={rating.value}
                maxLength={rating.maxLength}
                className='-ml-1'
                readOnly
              />
            </>
          ),
          boolean: <span>{rating.value ? 'Yes' : 'No'}</span>,
        }[rating.type]
      }
    </div>
  );
}
